import React, { useState } from "react";
import { Row, Col, Card, Form, Input, Spin, Button, Checkbox } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { CustomBtn } from "../../../components/Button";
import { PinCodeDialog } from "../../../components/Dialog/pincode-dialog";
import { useBillCMACGMGetMutation, useBillCMACGMPayMutation, useBillFeesMutation } from "../../../redux/bills/bill-cmacgm-api";
import { showDialog } from "../../../redux/dialog/dialog-slice";
import { handleApiError } from "../../../utils/errorHandler";

export function BillCmacgmPage() {
    const dispatch = useDispatch();
    const [billCMACGMGet] = useBillCMACGMGetMutation();
    const [billCMACGMPay] = useBillCMACGMPayMutation();
    const [billFees] = useBillFeesMutation();
    const { currentAgent } = useSelector((state) => state.auth);
    const [form] = Form.useForm();
    const [billCmacgm, setBillCmacgm] = useState([]);
    const [frais, setFrais] = useState([]);
    const [show, setShow] = useState(false);
    const dialog = useSelector((state) => state.dialog);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isCustomer, setIsCustomer] = useState(false);
    const [date, setDate] = useState("");
    const [error, setError] = useState();
    const [formdata, setFormData] = useState();
    const [referenceFacture, setReferenceFacture] = useState("")
    const [msisdn, setMsisdn] = useState("")
    const [referenceClient, setReferenceClient] = useState("")
    const [transaction, seTtransaction] = useState([])
    const [selectedInvoices, setSelectedInvoices] = useState([]);


    const handleCheckboxChange = (invoice) => {
        setSelectedInvoices((prevSelected) => {
            if (prevSelected.some(selected => selected.reference === invoice.reference)) {
                return prevSelected.filter(selected => selected.reference !== invoice.reference);
            } else {
                return [...prevSelected, invoice];
            }
        });
    };

    const handleSearch = async (value) => {
        setIsLoading(true);
        setReferenceFacture();
        setReferenceClient(value.referenceClient);
        setMsisdn(value.phone_number)
        const data = {
            "agent_msisdn": value.phone_number,
            "pincode": "",
            "reference": value.referenceClient,
            "service": "CMA_CGM",
            "operation": "GET",
            "token": currentAgent.access_token,
            "country": currentAgent.country
        };
        billCMACGMGet(data)
            .unwrap()
            .then((res) => {
                setIsLoading(false);
                setError();
                setBillCmacgm(res);
                setIsCustomer(true);
                form.setFieldsValue({
                    duration: res.duration,
                });
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error);
            });
    };

    function changeDate(date) {
        const getdate = date.split(' ')[0];
        const changeDate = getdate.split('-');
        const month = ["", "janvier", "fevrier", "mars", "avril", "mai", "juin", "juillet", "aout", "septembre", "octobre", "novembre", "decembre"];
        return changeDate[2] + " " + month[parseInt(changeDate[1])] + " " + changeDate[0];
    }

    const sommeAmounts = (data) => {
        return data.reduce((total, item) => total + item.amount, 0);
    }


    const handleFees = async () => {
        setIsLoading(true);
        const data = {
            operation: "COLLECTE",
            receiver: "11647",
            montant: sommeAmounts(selectedInvoices),
            country: currentAgent.country,
            agent_pin: "",
            token: currentAgent.access_token,
        };
        billFees(data)
            .unwrap()
            .then((res) => {
                setIsLoading(false);
                setError();
                setFrais(res);
                dispatch(showDialog({ isPinCode: true }))
                setShow(true);
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error);
                if ((error.data.status === "TOKEN_EXPIRED") || (error.data.status === "Unauthorized"))
                    dispatch(showDialog({ isLockscreen: true }));
                else
                    dispatch(showDialog({ isError: true, errorMessage: handleApiError(error.data) }));
            });
    };


    const handlePay = async (pin) => {
        setIsLoading(true);
        setShow(false);
        const data = {
            "reference": referenceClient,
            "service": "CMA_CGM",
            "operation": "RELOAD",
            "agent_msisdn": currentAgent.phone,
            "pincode": pin,
            "country": currentAgent.country,
            "additional_info": msisdn,
            "bills": selectedInvoices,
            "token": currentAgent.access_token
        };
        billCMACGMPay(data)
            .unwrap()
            .then(() => {
                setBillCmacgm([]);
                setIsSuccess(true);
                setIsLoading(false);
                setIsCustomer(false);
                dispatch(showDialog({ isSuccess: true, successMessage: "Transaction effectuée avec succès" }));
                form.resetFields();
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error);
                if ((error.data.status === "TOKEN_EXPIRED") || (error.data.status === "Unauthorized"))
                    dispatch(showDialog({ isLockscreen: true }));
                else
                    dispatch(showDialog({ isError: true, errorMessage: handleApiError(error.data) }));
            });
    };

    const getPin = (pin) => handlePay(pin)

    const resumeJson = {
        "title": "Paiement CMA CGM",
        "message": `Vous allez payer la facture numéro ${referenceClient} d'un montant de ${sommeAmounts(selectedInvoices)} F CFA expirant le ${date}.`,
        "fees": frais.fees
    }


    return (
        <div className="default-page">
            {dialog.isPinCode && <PinCodeDialog resume={resumeJson} pinCode={getPin} />}
            <Spin tip="Chargement..." spinning={isLoading}>
                <Row gutter={16}>
                    <Col lg={12} xs={24}>
                        <Card>
                            <h1>PAYEMENT CMA CGM</h1>
                            <Form
                                name="basic"
                                form={form}
                                layout="vertical"
                                initialValues={{ remember: true }}
                                onFinish={handleSearch}>
                                <Form.Item
                                    label="Numéro de téléphone client"
                                    name="phone_number"
                                    rules={[{ required: true, message: "Veuillez saisir un numéro" }]}>
                                    <Input
                                        className="form-control"
                                        placeholder="Numéro de téléphone client"
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Numéro compte client"
                                    name="referenceClient"
                                    rules={[{ required: true, message: "Veuillez saisir un numéro" }]}>
                                    <Input
                                        className="form-control"
                                        placeholder="Numéro compte de contrat"
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <CustomBtn title={billCmacgm.status === "success" ? "Valider" : "Chercher"} />
                                </Form.Item>

                            </Form>
                        </Card>
                    </Col>
                </Row>
                <br />
                {(billCmacgm.length !== 0) && (
                    <div>
                        <h4>Veuillez selectionner un ou plusieurs factures à payer</h4>
                        {billCmacgm.invoices.length > 0 ?
                            <Row gutter={24}>
                                {billCmacgm.invoices.map((repo) => {
                                    return (
                                        <Col lg={7} xs={24} key={repo.reference}>
                                            <div className="invoices-content">
                                                <Card>
                                                    <Checkbox onChange={() => handleCheckboxChange(repo)}>
                                                        <h1> Référence facture: <span> {repo.reference}</span></h1>
                                                        <h1> Date écheance: <span>{changeDate(repo.due_date)}</span></h1>
                                                        <h1> Montant: <span>{repo.amount.toLocaleString('fr-FR')} FCFA</span></h1>
                                                    </Checkbox>
                                                </Card>
                                            </div>
                                            <br />
                                        </Col>
                                    )
                                })}
                            </Row> :
                            <Col lg={12} xs={24}>
                                <Card style={{ textAlign: 'center' }}>Il n'a aucune facture CMA CGM à payer pour ce
                                    numéro</Card>
                            </Col>}

                        <div>
                            {selectedInvoices.length > 0 &&
                                <Button className="ant-btn btn btn-secondary" type="primary" onClick={() => handleFees()}>{selectedInvoices.length} facture(s) à payer </Button>
                            }
                        </div>
                    </div>
                )}
            </Spin>
        </div>
    );
}

export default BillCmacgmPage;

